module.exports = __webpack_public_path__ + "images/syuccho_kaitori_lp/strong_point/1@2x_7544a99879ffc9a491d78727d4a9ada7.png";